import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";

export const useTranslated = (key, texts) => {
  const { lang } = useLanguage();
  const [out, setOut] = useState(texts);
  const sig = JSON.stringify(texts || []);

  useEffect(() => {
    const original = JSON.parse(sig);
    if (!original.length) { setOut(original); return; }
    if (lang.code === "en") { setOut(original); return; }
    let on = true;
    setOut(original);
    api.post("/translate", { key, lang_code: lang.code, lang_name: lang.name, texts: original }, { timeout: 90000 })
      .then((r) => on && setOut(r.data.texts))
      .catch(() => on && setOut(original));
    return () => { on = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, lang.code, sig]);

  return out || [];
};

export default useTranslated;
